import { topicEnMap, topicZhMap } from '@/pages/opinion/constants';
import useLanguage from '@op/hooks/useLanguage';
import { useCallback, useMemo } from 'react';
import { getLocale  } from 'umi';

export default function useDealwithTopic({ condTopicList }: any) {
  const [topicOneLevel, topicTwoLevel, topicTree] = useMemo(() => {
    let topicOneLevel: any = {};
    let topicTwoLevel: any = {};
    let topicTree: any = {};
    condTopicList?.forEach(
      ({ L1_topic, L1_topic_transl, topic_to_en, trans }: any) => {
        let oneKey = L1_topic?.toLocaleLowerCase();
        let twoKey = topic_to_en?.toLocaleLowerCase();
        if (!topicOneLevel[oneKey]) {
          topicOneLevel[oneKey] = {
            'en-US': topicEnMap[oneKey] || L1_topic,
            'zh-CN': topicZhMap[oneKey] || L1_topic_transl,
          };
        }

        topicTwoLevel[twoKey] = {
          'en-US': topicEnMap[twoKey] || topic_to_en,
          'zh-CN': topicZhMap[twoKey] || trans,
        };
        if (!topicTree[oneKey]) {
          topicTree[oneKey] = [];
        }
        topicTree[oneKey].push(twoKey);
      },
    );
    return [topicOneLevel, topicTwoLevel, topicTree];
  }, [condTopicList]);

  const topicOptions: any = useMemo(() => {
    let filterMap: any = {};
    if (condTopicList?.length > 0) {
      condTopicList.map(
        ({ L1_topic, L1_topic_transl, topic_to_en, trans }: any) => {
          let key = L1_topic?.toLocaleLowerCase?.();
          if (!filterMap[key]) {
            filterMap[key] = {
              value: key,
              text: topicEnMap[key] || L1_topic,
              textCN: topicZhMap[key] || L1_topic_transl,
              children: [],
            };
          }
          const key1 = topic_to_en?.toLocaleLowerCase?.();
          filterMap[key].children.push({
            value: key1,
            text: topicEnMap[key1] || topic_to_en,
            textCN: topicZhMap[key1] || trans,
          });
        },
      );
    }
    let resultOptions = Object.values(filterMap);
    return resultOptions;
  }, [condTopicList]);
  const { formatMessage } = useLanguage();
  const transTopic = useCallback(
    (
      topic: string,
      topicLevel: 'L1' | 'L2' = 'L2',
      language?: string,
      toLowerCase = false,
    ) => {
      const lang = getLocale();
      let topicInfo = topicLevel === 'L1' ? topicOneLevel : topicTwoLevel;
      const topicKey = topic?.toLocaleLowerCase?.();
      const info = topicInfo?.[topicKey]?.[language || lang] || topic;
      return toLowerCase ? info?.toLocaleLowerCase() : info;
    },
    [topicOneLevel, topicTwoLevel, formatMessage],
  );

  return {
    topicOneLevel,
    topicTwoLevel,
    topicTree,
    topicOptions,
    transTopic,
  };
}
